<template lang="pug">
transition(
name="cta"
)
  .scene-cta
    svg(ref="hand" viewBox="0 0 375 433" fill="none" xmlns="http://www.w3.org/2000/svg" )
      g(:transform="`translate(${-730*zoom} ${-365*zoom}) scale(${1+4.2*zoom})`")
        path(:transform="`translate(${-2*zoom} ${-10*zoom})`" d="M82.68 169.45a76.72 76.72 0 0 1-33.62-10l19.19-27.7c9 9.87 22.53-.97 35.84-1.9 5.8-.46 14.55-4.9 18.48-10.58 5.88-8.5 9.36-19.1 16.74-26.83l.04-.04c1.58-1.61 3.97-4.04 6.43-3.58 4.67.83-3.24 14.53-2.34 17.49 1.62 5.08 20.96-6.31 25.13-7.75.9-.32 11.14-4.73 12.06-2.75 1.53 3.43-1.24 4.5-3.3 5.62-3.16 1.72-4.47 2.31-7.43 3.97-.7.4-2.61 1.2-2.05 2.67.92 2.43 2.95 1.04 4.37.29 3.1-1.68 16.9-10.4 19.12-6.4 1.52 2.77-9.18 8.16-11.38 9.3-1.24.7-6.72 3.04-4.9 5.15 1.23 1.47 5.52-1.85 6.77-2.63 2.5-1.48 7.55-6.07 9.97-2.66 1.74 2.54-3.5 5.24-5.07 6.32-1.83 1.25-3.22 2.27-4.84 3.39-1.88 1.28-3.91 2.23-5.19 4.07-.65.9-.23 1.29.8 1.17 1.64-.23 4.69-1.87 5.84-2.36.63-.28 8.34-4.82 7.03-1.39-2.03 5.2-14 10.8-20.16 16.5-20.38 18.9-58.32 32-87.17 30.38l-.36.25z" fill="#E15125")
        path(d="M97.67 125.13c-8.1-3.96-45.92 10.88-66.98 33.15-6.59 6.97-18.35 20.76-39.99 43.1-38.34 39.65-78.55 98.75-77.08 99.52 10.82 5.68 28.32 5.03 33.83 16.03 12.56 24.99 28.82-17.72 85.7-83.34 12.42-14.33 26.21-32.22 43.92-44.71 6.01-4.26 19.53-10.23 25.56-15.1 5.3-4.32 6.92-6.64 3.37-13.85-4.88-9.7 5.81-27.9-8.33-34.8z" fill="#F3A01A")
        path(fill="#f0c63e" d="M45 202.8a45 45 0 0 1-4 4.1c-.3 0-2.6-1.8-2.6-1.7l3.4-3.7 1.2-1.6 1.3-3 1.3.3c.6.2 1.5.9 1.7 1 0-.1-1.6 3.6-2.4 4.6zM26.7 220.3s.1 0 0 0c.1 0 .1 0 0 0zM31.9 220.3l-3.1 1.8-2-2c-.1 0 0 0 0 0h-.1l5.8-5s1.8 1.5 2 2v.1h-.1.1v.1l-2.6 3zM17.4 221.9c-.5.4-2.7 1.4-2.9 1.3l-1.3-2.5 2-1 1.7-1.5 1 .8 1 1.1-1.4 1.8zM12.7 203.6l-2.7 2.1-2.2-2 5.8-5.7 2.2 2.2-3 3.4zM26.6 180.8l-2.8 2.9-2.6-1.4a94 94 0 0 0 4.8-6.2l2.5 1.9-2 2.8zM46.3 190.3c-.6.5-2.4 1.9-2.5 1.8l-2.2-1.9L43 189l3-3 2.2 2.2-1.8 2.1zM23.9 207.4c-.9 1-2.4 1.7-2.5 1.6l-1.5-2.3 1.6-1.2 1.3-1.6 1.2.4 1.7.8-1.8 2.3zM9.2 191.4l-2.8-.9 4-5.1.8 1c.5.5.9 1 1 1.3l-3 3.7zM3.9 251.8c-.2 0-2.2 2.4-2.4 2.4l-2.6-1.3 1.3-1.6L4 247l.9.9c.5.4 1.1 1.3 1.1 1.3l-2 2.6zM19.2 248s-2.6 2.8-2.8 2.7a40 40 0 0 1-2.5-1.3l2.8-3.2 2.5-3 2 2.3s-1.8 2.4-2 2.4zM9 233.3a13 13 0 0 1-2.5 2.4L5 233.4l2.4-3.2h3.1s-1 2.5-1.5 3.1zM9 221l.1.1v-.1zM6 224.2L3.5 223v.1c.1 0 0 0 0-.1 0 0-.1-.1 0 0l-.1-.2s.1 0 0 0c0-.1.3 0 .2-.1l3.5-3.4s0-.2.2-.2v-.2l.7 1 1 1.3c0 .1 0 0 0 0v.2c-.1 0 0 0 0 0 0 .2-2.9 2.8-3 2.8zM2.6 266.8zM-1.6 269.6c0-.2-1.9-2-1.9-2l3.8-3.2 1.8 2.4c0 .2-3.6 2.8-3.7 2.8zM18.7 236c-.4.5-1.5 1.9-1.7 1.9l-2.7-.8 1.8-2.8c.2-.1 1.7-2.5 1.7-2.5l1 .8 1.2 1.2-1.3 2.1zM50.2 211c-.4.8-2.5 3-2.7 3l-2.2-1.8 2-2.4 1-2.3 1.2.3 1.6.4h.1c0 .1 0 0 0 0l-1 2.7zM29 207c.1 0 .1 0 0 0zM33.3 207.4a10 10 0 0 1-2.3 1.7c-.1 0-1.9-2.2-2-2.1l2.2-1.7 1-1.4a67.6 67.6 0 0 0 2.5 1.4s-1 1.8-1.4 2.1zM23 191.9l-2.4-1.6 5.5-5 1.7 2.6-4.8 4zM86.7 152.3l-2-2 5.8-8.2 1.3.2 1.7.7M75 167.2l-2-1.9 5.7-5.1 2 2.3s-5.6 4.8-5.7 4.7zM63.4 167.2c-1 .6-2.6 1.2-2.7 1.2l-1.3-2.7s1.2-.3 2-.7c.7-.5 1.7-1.6 1.7-1.6l1 .8 1.1 1.4s-1.2 1.2-1.9 1.6zM59.4 148.4s-3.1 2.5-3.3 2.5l-2.2-2.1 3-2.7 3-3 2 2.2-2.5 3.1zM77.5 145.7l-2.4-1.4 4.7-6.2s2 1.2 2.4 1.6c0 0-4.5 6-4.7 6zM90 137.3l-2.2-2 4.4-4.1 2 2.1M71.8 150.1v.1zM70.5 152.7l-.8.5-2.1 1-1.5-2.6 2.2-1.5.7-1.1 1.2.4 1.6.7-1.3 2.6zM43 166.8s-2.6 2.8-2.7 2.7l-2.5-1.3 4.3-5.7s2.1 1.2 2.4 1.6M100 169c-.1 0-.2 0 0 0zM96.9 172.3a80 80 0 0 0-2.7-.8l.2-.7 3.8-4.5.8 1 .9 1.3-3 3.7zM73.8 183l-2.7-.7 1.6-2.5c.7-1 2.4-2.8 2.4-2.8l.8 1 1 1.3-3 3.7zM40.7 178zM42.8 179.8l-2.1-1.8c-.1 0 0 0 0 0l-.1-.1 3.6-3.5s1.8 1.6 2 2l.1.1-3.5 3.3zM62.7 195.9l-2.5-1.2 5.2-6.3 2.1 2.2-4.8 5.3zM55.7 178.4c-.6.7-2.9 2.5-3 2.5l-1.5-2.3s1-.5 1.7-1.5c.4-.7.7-1.7.7-1.7l3.2.4c0 .4-.8 2-1.1 2.6zM55.3 166.2zM52.2 169.4l-2.5-1.3 3.8-4 .7 1 1 1.6a33 33 0 0 1-3 2.7zM63.2 183l-2.7-1 2.3-3.4L64 177a153.8 153.8 0 0 0 2.1 1.8l.1.1s-2.8 4.1-3 4.1zM97.5 153.4zM93.8 159.2l-2.3-2 3-4.5 1.2.2a6 6 0 0 1 1.8.8c0 .2-3.6 5.4-3.8 5.5zM81 150.6zM77.2 154.3c0-.2-2-2.3-1.9-2.4l3.2-2.9a67.6 67.6 0 0 0 2.6 1.6M69 142.2l-2.3-1.8s5.4-4.6 5.6-4.6l1.5 2.2c0 .1 0 0 0 0l-4.7 4.2zM84.8 171a79 79 0 0 0-2.4-1.4l.4-.8 5-4.3 1.7 2.6c-.2.2-4.6 4-4.8 4zM40.9 157.1l-2.7-1c0 .1 0 0 0 0l6-6.8.9 1 .8 1.5-5 5.3zM29 168.8l-2.7-1 2.7-3.7 3.4-3.1.8 1 1 1.5s-5 5.3-5.2 5.3z")
        path(d="M270.74 160.24a53.24 53.24 0 0 0 28.19-10.15l-18.66-29.3c-7 10.27-19.48-1.27-31.02-2.38-5.03-.55-12.9-5.3-16.73-11.32-5.72-9-9.53-20.16-16.47-28.37l-.04-.05c-1.49-1.7-3.73-4.28-5.81-3.82-3.96.82 3.9 15.3 3.35 18.4-1 5.32-18.54-6.85-22.23-8.4-.8-.35-9.97-5.1-10.6-3.02-1.06 3.58 1.41 4.74 3.28 5.94 2.84 1.83 4.01 2.47 6.7 4.25.62.43 2.34 1.28 1.96 2.83-.6 2.54-2.46 1.06-3.74.25-2.8-1.8-15.35-11.1-16.95-6.92-1.1 2.89 8.53 8.67 10.51 9.89 1.12.75 6.02 3.26 4.62 5.46-.95 1.53-4.9-2-6.04-2.83-2.26-1.59-6.97-6.46-8.78-2.9-1.3 2.65 3.41 5.54 4.85 6.69 1.67 1.33 2.94 2.42 4.42 3.61 1.72 1.37 3.55 2.39 4.78 4.34.64.95.3 1.35-.6 1.22-1.42-.26-4.17-2.02-5.2-2.55-.57-.3-7.55-5.15-6.17-1.53 2.15 5.48 12.9 11.5 18.63 17.56 19.01 20.07 52.7 34.24 77.42 32.84l.33.26z" fill="#E15125")
        path(d="M252.6 113.76c6.66-4.58 41.69 10 62.87 33.22 6.62 7.26 18.6 21.69 40.3 44.97 38.43 41.3 80.82 103.5 79.62 104.4-8.84 6.53-24.32 6.5-27.86 18.55-8.08 27.43-27.46-18.01-85.29-86.63-12.63-14.98-26.88-33.75-43.94-46.55-5.8-4.37-18.4-10.28-24.28-15.3-5.18-4.47-6.88-6.91-4.62-14.82 3.14-10.65-8.42-29.87 3.2-37.84z" fill="#F3A01A")
        path(fill="#f0c63e" d="M308.5 196.2l4.1 3.8 1.7-2.2-2.2-2.2-4.1-6.3-1 .2c-.5.2-1.4 1-1.3 1l2.8 5.7zM326.3 213.7zM324.7 215.7l1.6-2.1-5.7-5.4-1.5 2.6s5.5 5 5.6 4.9zM337.4 216.4l.9-2.8-3.6-2.5-.7.9-.9 1.5s4.2 3 4.3 2.9zM339.3 197.3l1.8-2a217.5 217.5 0 0 1-6-6.1l-1.5 2.4 5.7 5.8zM324.6 174.1l2-1.5-5-6.6-1.8 2s4.6 6.1 4.8 6.1zM308 184l1.6-2.1-4.3-4.4s-1.6 2.5-1.5 2.6c.1.2 4 4 4.1 3.9zM329.7 201.3l1-2.5-2.9-3-1 .5-1.3 1s4.1 4.1 4.2 4zM355.6 211.3l2-1.5-4.5-6s-1.7 1.3-1.9 1.8l4.4 5.7zM338.3 181.9l2.4-.9-2-3c0-.2-2.1-2.3-2.3-2.3l-.5.8-.7 1.5 3.1 3.9zM354.6 228l1.7-2.3-3.6-3.3-1.6 2.3 3.5 3.4zM365 252.8s4.3 3.3 4.4 3.2l1.2-2.5-2.9-2.1c-.2 0-2.1-2.8-2.1-2.8l-.9.7c-.5.3-1 .8-1 1l1.2 2.5zM352.5 249.3l2.2-1.2-5.1-6.4-.7 1c-.4.4-.8 1.3-.8 1.3s4.3 5.3 4.4 5.3zM339 246.1l2-1.4-1.4-2-4-4.5-1.4 2.4s4.7 5.6 4.8 5.5zM343 227.3s2.8 2.3 3 2.2l1-2.6-1.6-1.4-1-1.8h-1c-.7 0-1.3.3-1.6.4 0 0 1 3.2 1.2 3.3zM371 242.3l1.4-2.3-6.5-5-1.2 2.6 6.3 4.7zM377.8 235.7l1.9-1.5-4.7-5.3-.6 1-.7 1.4 4 4.4zM369 221.2a54 54 0 0 0 2-1.5l-4.5-5-.6 1-.8 1.6 3.8 4zM345 217.1l2.1-1.4-3.8-4.3-.6 1.1-.7 1.6 3 3zM375.9 270.6l.2-4c-.2 0-1.9-2-1.9-2l-1.4 2.5 3 3.5zM369.1 280.8v0zM371.6 284.6c.2.1 3.4 2.4 3.6 2.4l1.3-2.4-1.8-1.5-3.7-4.2-.9.6c-.5.3-1.1 1.3-1.1 1.4l2.6 3.7zM357 265.8l1.5-2.4-3.7-3.2-1.4 2.6 3.7 3zM337 232.3l2.2-.9-1-1.9-2.6-3.7-.8.9-1 1.2 3.1 4.4zM307.3 207.7l1.7-2-3.3-4.8-1 .2-1.4.6s3.8 6 4 6zM321.2 201.8l1.4-2.3-3.1-3.3-.9.7a8 8 0 0 0-1.1 1l3.7 4zM326.2 183l2-1.8-1.6-1.8-3.6-3-1.5 2.1 4.7 4.4zM353.5 200.3l2.3-1.3-6.2-7-.6 1.1-.5 1.7 5 5.5zM267.2 140.5s-.1 0 0 0c-.1 0-.1 0 0 0zM261.6 139c.8 1 3.7 3.6 3.9 3.6 0-.1 1.5-2.3 1.6-2.2l-2.2-2.2-1.4-1.8-2.6-4.6s-.5 0-1 .3c-.6.2-1.5.8-1.5.8s2.1 4.7 3.2 6zM277.6 158.3l1.5-2.2-5.7-5.2s-1.3 1.8-1.4 2.3c0 0 5.5 5.1 5.6 5zM290.3 159l.8-2.7-3.6-2.4v-.2l-.7.9c-.3.5-.8 1-.8 1.3 0 .1 0 0 0 0M288.8 137.1c.7.8 3.3 2.9 3.4 2.9 0-.2 1.7-2.3 1.7-2.4l-5.8-5.8s-1.5 1.7-1.6 2.2c0 0 1.6 2.4 2.3 3.1zM272.8 135.1l2-1.8-1.4-1.6-3.5-4.6-2 1.8s4.7 6.2 4.9 6.2zM260.8 126.6l1.7-2.3-2.1-1.8-2.2-2.4-1.6 2.3 4.2 4.2zM282.5 144l1-2.6-2.8-3-1 .5-1.3.8s4 4.3 4.1 4.2zM308.3 159.5l2-1.6-4.4-6-2 2 4.4 5.6zM256.7 162.3c.1.1 2 2.3 2.2 2.3l2.4-.8-4.2-5.7-.6 1.1-.7 1.5c0 .1 0 0 0 0l1 1.6zM277.4 171.7v.1zM280.5 175.3l2.3-.9-1-1.9c-.2-.2-3-3.4-3.2-3.4 0 0-.3.2-.6.8l-.7 1.7s3 3.7 3.2 3.7zM309 168.6zM307.1 170.6l2-2.3-3.6-3.4s-1.4 1.8-1.6 2.3l3.2 3.4zM291.8 188.7l2-1.2-.5-1a132 132 0 0 0-4.8-5.4l-1.4 2.3s4.6 5.4 4.7 5.3zM296 169.9a15 15 0 0 0 2.8 2.3l1-2.6-1.7-1.5-.8-1.8h-2.6l1.3 3.6zM297.9 159.8l2-1.5-3.8-4.2-.5 1-.7 1.6s2.8 3 3 3zM288.1 173c0 .1 1.5 1.9 1.7 1.9l2.3-1-1-1.8-2.7-3.7-.7 1-1 1.1 1.4 2.6zM257.5 147.5c.5.8 2.4 2.8 2.6 2.8l1.7-2-3.1-5-1.1.4c-.6.1-1.4.5-1.4.5s.9 2.6 1.3 3.3zM274 144.4l1.4-2.3-3-3.3-1 .7-1.1 1 .5.9c.6 1 3.2 3 3.2 3zM277.3 129.3s2.3 1.8 2.5 1.8l1.8-1.9-5.4-5-1.1 2.8 2.2 2.3zM269.4 162.8l1.9-1.9-1.5-1.6-3.4-2.9-1.7 2.2 4.7 4.2zM301.2 140.4v0zM303.8 143.3c0 .1 2.4 2.8 2.6 2.8l2.2-1.1h-.1c0-.1 0 0 .1 0v-.2l-3-3.8-3.2-3.2-.5 1.1c-.3.6-.6 1.2-.6 1.6 0 .1 0 0 0 0l2.5 2.8zM315.9 155.5l2.3 2.7 2.3-1-1.6-2.4-4.6-4.8-.6 1-.6 1.8 2.8 2.7zM364.1 230l1.8-2.1-4.8-4.9-1.6 2.3c0 .1 0 0 0 0s4.5 4.7 4.6 4.6zM356.6 243.2l3 1.7c.2-.1 1.3-2.5 1.4-2.5l-5-4.6s-1.6 1.5-1.8 2l2.4 3.4zM376 255.4s1-2.8.9-3l-2.7-2.2-.4 1.2-.5 1.6 2.6 2.4z")
        path(style="opacity: 0" ref="up2" d="M187.38 56.53c.27-1.01-1.1-2.7-1.63-3.5-1.09-1.62-2.05-3.33-3.08-5-.86-1.41-1.87-2.52-2.87-3.78-.62-.77-1.18-3.27-2.45-3.25-.91.02-1.45 2.14-1.74 2.77-.69 1.47-1.75 2.81-2.63 4.19-1.24 1.92-2.45 3.88-3.68 5.8-.38.6-1.46 1.52-1.28 2.28.44 1.94 7.95 1 9.43 1l5.26-.05c1.1-.01 2.3.4 3.36.3.82-.06 1.2-.36 1.3-.76z" fill="#F8DEB1")
        path(style="opacity: 0" ref="up1" d="M187.38 31.53c.27-1.01-1.1-2.7-1.63-3.5-1.09-1.62-2.05-3.33-3.08-5-.86-1.41-1.87-2.52-2.87-3.78-.62-.77-1.18-3.27-2.45-3.25-.91.02-1.45 2.14-1.74 2.77-.69 1.47-1.75 2.81-2.63 4.19-1.24 1.92-2.45 3.88-3.68 5.8-.38.6-1.46 1.52-1.28 2.28.44 1.94 7.95 1 9.43 1l5.26-.05c1.1-.01 2.3.4 3.36.3.82-.06 1.2-.36 1.3-.76z" fill="#F8DEB1")
        path(style="opacity: 0" ref="down2" d="M168.04 189.52c-.28 1 1.1 2.7 1.62 3.5 1.1 1.62 2.05 3.33 3.08 5 .87 1.4 1.88 2.51 2.88 3.77.62.78 1.17 3.28 2.44 3.25.92-.01 1.46-2.14 1.75-2.76.68-1.47 1.74-2.82 2.63-4.19 1.24-1.93 2.44-3.88 3.68-5.81.38-.59 1.45-1.51 1.28-2.27-.44-1.94-7.95-1-9.43-1l-5.27.05c-1.1 0-2.3-.4-3.35-.3-.82.06-1.2.35-1.31.76z" fill="#F8DEB1")
        path(style="opacity: 0" ref="down1" d="M168.04 168.78c-.28 1 1.1 2.7 1.62 3.5 1.1 1.62 2.05 3.33 3.08 5 .87 1.41 1.88 2.51 2.88 3.78.62.77 1.17 3.27 2.44 3.25.92-.02 1.46-2.14 1.75-2.77.68-1.47 1.74-2.81 2.63-4.19 1.24-1.93 2.44-3.88 3.68-5.8.38-.6 1.45-1.52 1.28-2.28-.44-1.94-7.95-1-9.43-1l-5.27.05c-1.1 0-2.3-.4-3.35-.3-.82.06-1.2.36-1.31.76z" fill="#F8DEB1")
        path(d="M202 74.2v76.5c-.7 2-2.2 2.6-4.2 2.6H155c-2.3 0-3.6-1.4-3.6-3.7V75.3c0-2.4 1.3-3.6 3.6-3.6h42.7c2 0 3.5.6 4.3 2.5z" fill="#f8b037")
        path(d="M181.1 80h-8.6c-2.3 0-3.9-3-4.1-3.4h-10.2c-1 0-1.9.8-1.9 1.9v68c0 1 .8 1.8 1.9 1.8h37.2c1 0 1.9-.8 1.9-1.9v-68c0-1-.9-1.8-2-1.8h-10c-.2.5-1.1 3.4-4.2 3.4z" fill="#fff")
        path(:style="`opacity:${1-zoom}`" d="M194.53 115.06c-1.65-.53-.9-2.31.47-2.66 1.94-.48 1.74 3.36-.47 2.66zM175 114.28a1.57 1.57 0 0 1-.2-.95c.08-.92 1-1.38 1.84-1.33.6.04 1.3.18 1.55.77.39.91-.12 2.15-1.17 2.3-.23.03-.53.02-.77 0a1.6 1.6 0 0 1-1.24-.79zM188.9 112.4c.5-.09 1.01.04 1.38.4.4.37.36 1.35.13 1.8-.56 1.08-2.01.8-2.47-.18-.4-.88-.04-1.83.96-2.02zM165.8 112.4c.5-.09 1.02.04 1.4.4.38.37.35 1.35.11 1.8-.55 1.08-2 .8-2.46-.18-.4-.88-.04-1.83.95-2.02zM170.26 112.6c.17-.03.34-.04.48-.03.61.02.87.71.75 1.24-.16.75-.59 1-1.32.93-.31-.03-.54-.33-.67-.6-.15-.33-.22-.72-.05-1.07.12-.24.47-.4.8-.46zM181.6 114.64a1.57 1.57 0 0 1-.16-1.43c.2-.5 1.12-.85 1.63-.8 1.2.1 1.5 1.55.77 2.34-.66.72-1.68.74-2.23-.1zM159.27 114.64a1.56 1.56 0 0 1-.17-1.43c.2-.5 1.12-.85 1.63-.8 1.2.1 1.5 1.55.77 2.34-.66.72-1.68.74-2.23-.1z" fill="#F2C222")

    .copy(ref="copy")
      .line 上下摆动手机
      .line 可切换模式
    .ios122-warning(ref="ios122Warning" v-if="isIOS122 && isSafari")
      .content
        .title
          .line 请打开动作感应
          .line 以获得完整体验
        .instructions
          .step
            span 1.打开系统设置
            img(src="~assets/ui/settings.png")
          .step
            span 2.进入
            span.en Safari
            span 设置
            img(src="~assets/ui/safari.png")
          .step
            .line 3.打开"动作与方向访问"
            img.motion(src="~assets/ui/motion.png")
      //.confirm-btn(@click="confirmBtn") 我已了解
      .button.follow(@click="confirmBtn")
        svg.frame(width="100%" viewBox="0 0 130 20" xmlns="http://www.w3.org/2000/svg")
          rect(:x="`${56-zoom2*55}`" y="1" :width="`${18+zoom2*110}`" height="18" rx="9" ry="9" fill="#F3A01A" stroke="none")
        .btn-content(:style="`transform: translate3d(${-250*zoom2}%, 0, 0);`")
          .cp
            .line(:style="`transform: translate3d(${-100*(1-zoom2)}%, 0, 0);`") 好的


</template>

<script>
  import { mapState, mapMutations } from 'vuex'
export default {
  name: 'scene-cta',
  props: {
    progress: {
      //required: true,
      default: 0,
    },
  },
  components: {},
  data() {
    return {
      counter: 5,
      zoom: 0,
      zoom2: 0
    }
  },
  computed: {
    ...mapState('browser', ['isIOS122', 'isSafari'])

  },
  mounted() {

    this.animeIn()


  },
  beforeDestroy() {},
  methods: {
    confirmBtn(){
      this.$emit('complete')
    },
    animeIn(){
      let tl = new TimelineMax({ onComplete: () => {

          if (this.isIOS122 && this.isSafari) {
            let tl = new TimelineMax({ onComplete: () => {},})
            this.tl = tl
            tl.add('start')

              .to(
                this.$refs.hand,
                1,
                {
                  y: -30,
                  ease: Power2.easeOut
                },
                `start+=0`
              )
              .to(
                this,
                0.5,
                {
                  zoom: 1,
                  ease: Power2.easeOut
                },
                `start+=0`
              )
              .to(
                this.$refs.copy,
                0.5,
                {
                  opacity: 0,
                  ease: Power2.easeOut
                },
                `start+=0`
              )
              .to(
                this,
                1,
                {
                  zoom2: 1,
                  ease: Power2.easeOut
                },
                `start+=0.5`
              )
              .to(
                this.$refs.ios122Warning,
                1,
                {
                  opacity: 1,
                  ease: Power2.easeOut
                },
                `start+=0.5`
              )


          } else {
            this.$emit('complete')
          }


        },

      })
      this.tl = tl

      let handT = 1
      let arrT = 0.5
      let arrOfs = 0.2
      let ease = Power2.easeOut



      tl.add('start')
        .set(
          this.$refs.hand,
          {
            y: 100,
          },
          `start+=0`
        )
        .to(
          this.$refs.hand,
          1,
          {
            y: -100,
            ease: Power2.easeInOut
          },
          `start+=0`
        )
        .to(
          this.$refs.up2,
          0.5,
          {
            opacity: 1,
            ease: ease
          },
          `start+=0.8`
        )
        .to(
          this.$refs.up2,
          0.5,
          {
            opacity: 0,
            ease: ease
          },
          `start+=1.3`
        )
        .to(
          this.$refs.up1,
          0.5,
          {
            opacity: 1,
            ease: ease
          },
          `start+=1.1`
        )
        .to(
          this.$refs.up1,
          0.5,
          {
            opacity: 0,
            ease: ease
          },
          `start+=1.6`
        )
        .to(
          this.$refs.hand,
          1,
          {
            y: 100,
            ease: Power2.easeInOut
          },
          `start+=2.2`
        )
        .to(
          this.$refs.down1,
          0.5,
          {
            opacity: 1,
            ease: ease
          },
          `start+=2.7`
        )
        .to(
          this.$refs.down1,
          0.5,
          {
            opacity: 0,
            ease: ease
          },
          `start+=3.2`
        )
        .to(
          this.$refs.down2,
          0.5,
          {
            opacity: 1,
            ease: ease
          },
          `start+=3`
        )
        .to(
          this.$refs.down2,
          0.5,
          {
            opacity: 0,
            ease: ease
          },
          `start+=3.5`
        )
    }

  },
  watch: {
    showQRPage(val){
      if (!val){
        this.setCounter()
      }
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

.scene-cta
  pointer-events: all
  +full()
  display: flex
  justify-content: center
  align-items: center
  background: rgba(21, 33, 80, 0.6)
  svg
    width: 100%
  .copy
    width: 100%
    position: absolute
    top: 65%
    text-align: center
    .line
      font-size: $fs-xl
      color: $cl-lightGold
      line-height: 1.5
      transform-origin: center
      transform: rotateZ(-10deg)
  .ios122-warning
    +full()
    opacity: 0
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    .content
      width: 70%
      height: 60%
      margin-top: -0.5rem
      //border: #e15125 5px solid
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      .title
        font-size: $fs-l
        color: $cl-gold
        margin-bottom: 0.5rem
        line-height: 1.5
        //background: black
      .instructions
        font-size: $fs-s
        color: $cl-gold
        .step
          height: 0.6rem
          display: flex
          flex-direction: row
          justify-content: flex-start
          align-items: center
          .en
            letter-spacing: -4px
          img
            display: inline-block
            height: $fs-m*1.2
            margin-left: 5px
          .motion
            position: absolute
            margin-top: 0.4rem
            height: $fs-m*1.6

    .confirm-btn
      font-size: $fs-m
      color: $cl-gold
    .button
      position: absolute
      bottom: 0.5rem
      pointer-events: all
      //background: #ff55ac
      line-height: 0
      height: $fs-s*2.5


      font-size: $fs-s
      display: flex
      flex-direction: row
      justify-content: center
      align-items: center

      text-align: center
      margin: 0.25rem auto
      //width: 60%
      width: 3rem
      //border: white 2px solid
      .frame
        position: absolute
        top: -10%
        left: 0

      .btn-content
        position: relative
        color: white
        .cp
          position: absolute
          width: $fs-m*5
          top: -$fs-m
          left: -$fs-m*2
          //background: black
          line-height: $fs-m*2
          height: $fs-m*2
          white-space: nowrap
          letter-spacing: 0.2rem
          overflow: hidden


.cta-enter-active, .cta-leave-active
  transition: all 0.5s ease 0s
.cta-enter, .cta-leave-to
  opacity: 0










</style>
